import { RECRUITEE_BACKEND } from '@recruitee/environment/staging';

import { AccountSetupEnvironment } from './interface';
export const environment: AccountSetupEnvironment = {
  environmentName: 'staging',
  angularProdMode: true,
  hmr: false,
  analytics: {
    isEnabled: true,
    key: 'DlaokckWxNBiyBoQUTZJGRRF4MeRanyf',
    requiredFeatureFlag: false,
  },
  i18n: {
    phraseAppProjectId: 'cea66a528621d963077fdbb152355ac8',
    editorEnabled: true,
  },
  protocol: RECRUITEE_BACKEND.protocol,
  domain: RECRUITEE_BACKEND.domain,
  webappUrl: RECRUITEE_BACKEND.webAppUrl,
  landingPageUrl: RECRUITEE_BACKEND.appUrl,
  apiUserUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-admin`,
  apiSSOUserUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-sso`,
  apiADPUserUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-adp`,
  apiUserDataUrl: `${RECRUITEE_BACKEND.authUrl}/invitation/`,
  apiLocalizationSettingsUrl: `${RECRUITEE_BACKEND.apiUrl}/localization_settings`,
  apiCompanyUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up`,
  apiCompanyDataUrl: `${RECRUITEE_BACKEND.authUrl}/sign-up-confirmation/`,
  appAuthUrl: `${RECRUITEE_BACKEND.authUrl}/`,
  signInUrl: `${RECRUITEE_BACKEND.authUrl}/sign-in/`,
  emailConfirmationUrl: `${RECRUITEE_BACKEND.authUrl}/email-confirmation/`,
  supportEmail: 'support@recruitee.com',
  growsumoPublicKey: 'pk_86389cd9dcf0488c81b2113893302a82',
  sentry_dsn: 'https://80c6c6f0815e4694ac9e40ecffcfea54@o18167.ingest.sentry.io/1807450',
};
